export * from "./departments-submenu.component";